module.exports = __webpack_public_path__ + "img/logo5@2x.522f31a8.png";